import { render, staticRenderFns } from "./OrderDetailIframe.vue?vue&type=template&id=5bc27e17&"
import script from "./OrderDetailIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports